<script>
  import { getList } from "../api";
  import Loader from "../components/Loader.svelte";
  import NewTable from "../components/table/Table.svelte";
  // import { headerDisplayStore } from "../stores/General";

  export let publisher_id;

  let module_name = "publisher/channels";
  let data = [];
  let loading = true;
  let columns = [
    {
      label: "Channel",
      dataKey: "name",
      sortBy: "name",
      renderBy: "formatter",
    },
    {
      label: "Channel ID",
      dataKey: "id",
      sortBy: "id",
      renderBy: "formatter",
    },
    {
      label: "Language",
      dataKey: "language",
      sortBy: "language",
      renderBy: "formatter",
    },
  ];
  let page = 1;
  let pageSize = 100;
  let count = 0;

  function onActionClick({ detail }) {
    const { action, row } = detail;

    switch (action.key) {
      case "edit":
        break;
    }
  }

  async function fetchChannelsForPublisher(publisher_id) {
    try {
      data = [];
      // loadingStore.on(module_name, { disableGlobalIndicator: true });
      loading = true;
      const res = await getList(module_name, null, null, "name", "ASC", {
        publisher_id,
      });
      data = res.data;
    } catch (error) {
      // headerDisplayStore.ShowError({
      //   title: "Failed to load channels for publisher",
      //   subtitle: error?.message,
      // });
      console.error(error);
      loading = false;
    } finally {
      // loadingStore.off(module_name);
      loading = false;
    }
  }

  $: fetchChannelsForPublisher(publisher_id);
</script>

<div class="block">
  <Loader size={2} class="h-8 relative" {loading} />
</div>

{#if data.length}
  <NewTable
    {data}
    {columns}
    config={{
      tableId: "publishers_channels",
      stickyHeader: true,
      stickyFirstColumn: false,
      stickyLastColumn: false,
      multilineColumns: false,
      showCheckboxes: false,
      enableDeleteAll: false,
      enableSubTables: false,
    }}
    class="h-auto max-h-[200px] rounded-none"
    dataKey="id"
    isChildTable={true}
    pagination={{ page, pageSize, count }}
    on:actionClick={onActionClick}
  />
{:else}
  <div class="h-[100px] text-center flex flex-col justify-center text-gray-400">
    {!loading ? "Publisher has no channels" : ""}
  </div>
{/if}
